export const errorMessage = (error) => {
  const { data } = error.response || {};

  if (!data) {
    return "An unknown error occurred.";
  }

  if (typeof data.message === "string") {
    return data.message;
  }

  if (typeof data.message === "object" && data.message !== null) {
    return Object.values(data.message).flat().join(", ");
  }

  if (data.error) {
    return data.error;
  }

  return "An error occurred.";
};

export const capitalize = function (str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const safeJSONParse = (raw, fallback = null) => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};
